import loadable from '@loadable/component';

export const LoadableSomethingWentWrong = loadable(
  () => import(/* webpackChunkName: "ErrorPages" */ './SomethingWentWrong'),
);
